import React from "react";
import Footer from "../../components/Footer";
import NavLite from "../../components/NavLite";


function Testimonials() {
  return (
    <main>
    <title>Success Stories | What Women Entrepreneurs Say About Us | Her Growth Co.</title>
  <meta
  name="description"
  content="Read reviews from our clients—female founders and coaches who transformed their business with our design and SEO services."
  />
  <meta
  name="keywords"
  content="client love from women founders, testimonials from female entrepreneurs, success stories from brand strategy, feedback from visionary clients, trusted by women-led brands, results-driven agency reviews"
  />
    <div>
<NavLite/>
      <div className="text-center items-center justify-center text-9xl mt-10">
     
        Coming Soon
        </div>
        <Footer />
     
    </div>
    </main>
  );
}

export default Testimonials

